import React from 'react'
import { GraduationCap } from 'lucide-react'

import SchoolSearch from '.'

import { Modal, ModalHeader, ModalTitle, ModalContent, ModalFooter, Button } from '@/components/tailwind-ui'

function SchoolsModal({ open, onClose, onSelect }) {
  const [school, setSchool] = React.useState(null)

  const handleSelect = () => {
    onSelect(school)
    onClose()
  }

  return (
    <Modal closeOnBackdrop showCloseButton open={open} size="lg" onClose={onClose}>
      <ModalHeader>
        <ModalTitle className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full">
            <GraduationCap className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Choose Your School</h2>
            <p className="text-sm text-gray-600 mt-1">Search and select your educational institution</p>
          </div>
        </ModalTitle>
      </ModalHeader>

      <ModalContent className="py-6">
        <div className="space-y-4">
          <div className="text-sm text-gray-700">Start typing to search for your school or institution</div>
          <SchoolSearch setValue={setSchool} value={school} />
          {/* {school ? (
            <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="flex items-center gap-2">
                <GraduationCap className="w-4 h-4 text-blue-600" />
                <span className="text-sm font-medium text-blue-900">Selected School:</span>
              </div>
              <p className="text-sm text-blue-800 mt-1">{school?.name || school}</p>
            </div>
          ) : null} */}
        </div>
      </ModalContent>

      <ModalFooter>
        <Button className="mr-2" variant="ghost" onClick={onClose}>
          Cancel
        </Button>
        <Button className="min-w-[100px]" disabled={!school} variant="brand" onClick={handleSelect}>
          Select School
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default SchoolsModal
